import * as yup from 'yup'

export const createGroupSchema = yup.object().shape({
    name: yup.string().required('Введите название группы')
})

export const groupAccrualValidationSchema = yup.object().shape({
    bonus_id: yup.string().required('Выберите бонус'),
    amount: yup.number().typeError('Укажите число').required('Укажите количество бонусов'),
    comment: yup.string()
})

export const visibilityAclValidationSchema = yup.object().shape({
    acl_strategy: yup.string().optional(),
    visible_group_ids: yup.array().of(yup.string()).nullable().optional()
})